import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const phraseresponses = 
{
    namespaced: true,
    state: {
        phraseresponses: [],
        phraseresponse: {}
    },
    mutations: {
        SET_PHRASERESPONSES(state, data)
        {
            state.phraseresponses = data
        },
        SET_PHRASERESPONSE(state, data)
        {
            state.phraseresponse = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'PhraseResponse', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_PHRASERESPONSES', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deletePhraseResponse ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updatePhraseResponse({ commit }, {id, data}){
            return axios
            .post(baseUrl+'PhraseResponse/updatePhraseResponse/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getPhraseResponse ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewPhraseResponse ({ commit }, data) {
            return axios
            .post(baseUrl+'PhraseResponse/addPhraseResponse', data, { withCredentials: true },)
            .then(res => {
                console.log("new phrase response added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default phraseresponses